import { render } from "./InputUpload.vue?vue&type=template&id=947dd094&scoped=true"
import script from "./InputUpload.vue?vue&type=script&lang=js"
export * from "./InputUpload.vue?vue&type=script&lang=js"

import "./InputUpload.vue?vue&type=style&index=0&id=947dd094&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-947dd094"]])

export default __exports__